const dsSliderCustomScale = require("./ds-slider-custom-scale");

module.exports = dsSliderCustomScale;
